import React from 'react';
import { Helmet } from 'react-helmet-async';
import { m } from 'framer-motion';
import './DuskAccount.scss';
import { Button } from 'components/Button/Button';
import { EggTab, EggTabs } from 'components/Egg/EggTabs';
import { Link, Outlet } from 'react-router-dom';
import MetamaskLogin from 'components/Login/MetamaskLogin';
import { routes } from '../../routing/routes';
import { useUser } from '../../hooks/useUser';
import { FLAGS, useFlags } from 'hooks/useFlags';

const DuskAccount = () => {
  const { account, ethereum, logout } = useUser();
  const { isFlagEnabled } = useFlags();
  const isWeb3Connected = ethereum.isConnected;

  const tabs: EggTab[] = [
    {
      name: 'Breakers',
      link: routes.duskAccount.base(),
      controls: 'breakers',
      id: 'breakers-tab',
    },
    ...(isFlagEnabled(FLAGS.hatchening)
      ? [
          {
            name: 'Gribbles',
            link: routes.duskAccount.gribbleCollection(),
            controls: 'gribbles',
            id: 'gribbles-tab',
          },
        ]
      : []),
    {
      name: 'Eggs',
      link: routes.duskAccount.eggCollection(),
      controls: 'eggs',
      id: 'eggs-tab',
    },
    {
      name: 'Badges',
      link: routes.duskAccount.badgeCollection(),
      controls: 'badges',
      id: 'badges-tab',
    },
  ];

  return (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="dusk-account"
    >
      <Helmet>
        <title>Account - DuskBreakers</title>
        <meta name="description" content="Manage your DuskBreakers account here." />
      </Helmet>

      <section className="account-container">
        <div className="container-fluid">
          <div className="row">
            <div className="account-control">
              <h1>Account</h1>
              <div className="account-buttons">
                {!isWeb3Connected ? (
                  <Link className="nav-link" to={routes.loginMetamask()}>
                    <Button small primary>
                      Connect wallet
                    </Button>
                  </Link>
                ) : !account?.dusktech?.userId ? (
                  <Link className="nav-link" to={routes.loginDusktech()}>
                    <Button small primary>
                      Connect Breaker ID
                    </Button>
                  </Link>
                ) : (
                  <Button small onClick={() => logout(routes.home())}>
                    Logout
                  </Button>
                )}
              </div>
            </div>

            <EggTabs tabs={tabs} linkEnd={true} />

            <div className="mt-3">{isWeb3Connected ? <Outlet /> : <MetamaskLogin />}</div>
          </div>
        </div>
      </section>
    </m.main>
  );
};

export default DuskAccount;
